import React, { useState } from 'react'
import transition from "../transition";
import {Typewriter, Cursor} from "react-simple-typewriter";
import ContactTiltCard from './ContactTiltCard';
import MouseImageTrail from './MouseImageTrail';
import trailImages from '../trailImages';
import { EMAIL, LOCATION, RESUME, links } from '../links';
import icons from '../icons';

const pill = "rounded-full bg-emerald-100/75 px-5 py-2 font-bold shadow-lg transition-transform hover:scale-105";

const Contact = () => {
  const [copied, setCopied] = useState("");

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied("Copied!");
    } catch {
      // fallback for browsers/contexts without the async clipboard API
      const box = document.createElement("textarea");
      box.value = EMAIL;
      document.body.appendChild(box);
      box.select();
      const ok = document.execCommand("copy");
      box.remove();
      setCopied(ok ? "Copied!" : "Couldn't copy");
    }
    setTimeout(() => setCopied(""), 2000);
  };

  return (
    <div>
      <h1>
        <Typewriter className = "typeWriter" words= {['.joyastick', '.js', 'contact.js']}/><Cursor />
      </h1>
      <MouseImageTrail renderImageBuffer={150} rotationRange={25} images={trailImages}>
      <div className="relative z-[1000] mx-auto flex max-w-3xl flex-col items-center gap-8 px-4 pb-24 pt-20 lg:min-h-[calc(100vh-var(--nav-h))] lg:max-w-5xl lg:flex-row lg:justify-center lg:gap-16 lg:py-0">
        <div className="flex flex-col items-center gap-6">
          <ContactTiltCard/>

          <p className="text-frost relative px-10 py-4 text-center text-lg font-medium">📍 {LOCATION}</p>

          <div className="flex flex-wrap justify-center gap-3">
            <button onClick={copyEmail} className={pill}>
              {copied || "Copy email"}
            </button>
            {RESUME && (
              <a href={RESUME} download className={pill}>
                Download résumé
              </a>
            )}
          </div>
        </div>

        <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2 lg:w-[34rem]">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              target="_blank"
              rel="noreferrer"
              className="rounded-xl bg-emerald-900/80 p-3 shadow-xl shadow-black/30 transition-transform hover:scale-[1.02] sm:[&:nth-child(odd):last-child]:col-span-2 sm:[&:nth-child(odd):last-child]:mx-auto sm:[&:nth-child(odd):last-child]:w-[calc(50%-0.625rem)]"
            >
              <div className="rounded-xl bg-emerald-100/75 p-4 text-center shadow-lg">
                {icons[l.label] && (
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="mx-auto mb-2 h-9 w-9 text-emerald-900">
                    <path d={icons[l.label]} />
                  </svg>
                )}
                <p className="text-2xl font-bold">{l.label}</p>
                <p className="font-medium">{l.note}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
      </MouseImageTrail>
    </div>
  )
}

export default transition(Contact);
